import { ProductDetails, ProductDetailsSkeleton } from 'components/product';
import { Breadcrumbs, Error } from 'components/ui';
import * as BreadcrumbsHelpers from 'helpers/BreadcrumbsHelpers';
import { useAccessibilityToolbar } from 'hooks/common/useAccessibilityToolbar';
import { useProduct } from 'hooks/data/useProduct';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { useRouteQueryAnalyticsListProps } from 'hooks/useRouteQueryAnalyticsListProps';

import styles from './ProductTemplate.module.scss';

interface Props {
  slug: string
}

const ProductTemplate = (props: Props) => {
  const {
    slug
  } = props;

  // Hooks

  const isBreakpoint = useMediaQuery(`(max-width: ${styles.breakpoint_lg})`);
  const { analyticsListProps } = useRouteQueryAnalyticsListProps();

  useAccessibilityToolbar();

  // Data Hooks

  const {
    data: product, isError, isLoading
  } = useProduct(slug);

  // Error

  if (isError) {
    return <Error />;
  }

  // Loading

  if (isLoading) {
    return <ProductDetailsSkeleton />;
  }

  // Render

  if (product) {

    const { isGift } = product || {};

    const breadcrumbItems = isGift
      ? BreadcrumbsHelpers.getBreadcrumbsFromTrail(product?.breadcrumbs.slice(-1))
      : BreadcrumbsHelpers.getBreadcrumbsFromTrail(product?.breadcrumbs, { omitLast: true });

    // Render

    return (
      <>
        {/* Breadcrumbs */}
        <Breadcrumbs
          className={styles.breadcrumbs}
          disableLast={isGift}
          items={breadcrumbItems}
        />

        {/* Content */}
        <div className={styles.content}>
          <ProductDetails
            isQuickView={false}
            product={product}
            listProps={analyticsListProps}
            //
            withoutLinks={isGift}
            withoutBanner={isGift}
            withoutSameBrandNavigation={isGift}
            withoutActions={isGift}
            withoutTrustedElements={isGift}
            withoutToolbar={isBreakpoint}
            //
            onItemClick={() => {
              window.scrollTo(0, 0);
            }}
          />
        </div>
      </>
    );
  }

  return null;
};

export default ProductTemplate;
